import React, { useState, useRef, useEffect } from "react";
import "./SchoolBusNavMenu.css";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useSchoolNavLayout } from "../../hooks/useSchoolNavLayout";

export default function SchoolBusNavMenu() {
  const { t } = useTranslation();
  const location = useLocation();
  const menuItems = useSchoolNavLayout();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const timeoutRef = useRef(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const menuRef = useRef(null);

  const isActiveRoute = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(`${path}/`)
    );
  };

  const handleMouseEnter = (index) => {
    if (isMobileView) return;
    clearTimeout(timeoutRef.current);
    setHoveredItem(index);
  };

  const handleMouseLeave = () => {
    if (isMobileView) return;
    timeoutRef.current = setTimeout(() => {
      setHoveredItem(null);
    }, 300);
  };

  const toggleMobileMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleItemClick = (index) => {
    if (isMobileView) {
      setHoveredItem(hoveredItem === index ? null : index);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMobileView && isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileView, isMenuOpen]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobileView(mobile);
      if (!mobile && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [isMenuOpen]);

  const isAlertsItem = (item) => {
    return (
      item.showBadge ||
      item.path === "/school-alerts" ||
      item.path === "/alert" ||
      item.label === "Alerts"
    );
  };

  return (
    <div className="school-bus-nav-container" ref={menuRef}>
      {isMobileView && (
        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {isMenuOpen ? <Close /> : <Menu />}
        </div>
      )}

      <div
        className={`school-bus-nav-menu ${isMobileView ? "mobile" : ""} ${
          isMenuOpen ? "open" : ""
        }`}
      >
        {menuItems.map((item, index) => {
          const isActive = isActiveRoute(item.path);

          return (
            <div
              key={item.id || index}
              className="nav-item-wrapper"
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleItemClick(index)}
            >
              <NavLink
                to={item.path}
                className={
                  isActive
                    ? "school-bus-sub-data active-link"
                    : "school-bus-sub-data"
                }
                onClick={(e) => {
                  if (item.onClick) {
                    e.preventDefault();
                    item.onClick();
                  }
                }}
              >
                <span
                  className={`nav-icon ${isAlertsItem(item) ? "has-badge" : ""}`}
                >
                  {item.icon}
                  {isAlertsItem(item) && <span className="alert-badge" />}
                </span>
                {!isMobileView && (hoveredItem === index || isActive) && (
                  <span className="nav-item-label">{t(item.label)}</span>
                )}
                {isMobileView && (
                  <span className="nav-item-label">{t(item.label)}</span>
                )}
              </NavLink>
            </div>
          );
        })}
      </div>
    </div>
  );
}
